export default __webpack_public_path__ + "static/media/Ew.f14343ea.gif";